import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Button, Modal, FloatingLabel, Tooltip, OverlayTrigger } from 'react-bootstrap';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';
import '../sources/styles/stylesTexto.css';
import Cookies from 'universal-cookie';

function RegistroUsuario(props) {

    const location = useLocation();
    const cookies = new Cookies();
    const [show, setShow] = useState(false);
    const [mensaje, setMensaje] = useState();
    const [disabledButton, setDisabledButton] = useState(false);
    const [arrayDepartamentos, setArrayDepartamentos] = useState([]);
    const [arrayCiudades, setArrayCiudades] = useState([]);
    const [mensajeValidacionTelefono, setMensajeValidacionTelefono] = useState();
    const [mensajeValidacionPassword, setMensajeValidacionPassword] = useState();
    const [mensajeValidacionEmail, setMensajeValidacionEmail] = useState();
    const [mensajeValidacionNombre, setMensajeValidacionNombre] = useState();
    const [mensajeValidacionApellido, setMensajeValidacionApellido] = useState();
    const [mensajeValidacionDireccion, setMensajeValidacionDireccion] = useState();
    const [mensajeValidacionTerminos, setMensajeValidacionTerminos] = useState();
    const [validated, setValidated] = useState(false);
    const [patternIdentificacion, setPatternIdentificacion] = useState({
        soft: '',
        hard: '',
        name: '',
        lastname: '',
        tooltipName: 'campo solo permite letras mayusculas, letras minusculas, letras con acento'
    });
    const patterns = {
        '': { soft: '', hard: '', name: '', lastname: '', tooltipName: '' },
        'CC': { soft: '^[1-9][0-9]{0,9}$', hard: '^[1-9][0-9]{3,9}$', name: '^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ ]{0,40}$', lastname: '', tooltipName: 'campo solo permite letras mayúsculas, letras minúsculas, letras con acento' },
        'CE': { soft: '^[a-zA-Z1-9][a-zA-Z0-9]{0,7}$', hard: '^[a-zA-Z1-9][a-zA-Z0-9]{3,7}$', name: '^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ ]{0,40}$', lastname: '', tooltipName: 'campo solo permite letras mayúsculas, letras minúsculas, letras con acento' },
        'TI': { soft: '^[1-9][0-9]{0,11}$', hard: '^[1-9][0-9]{4,11}$', name: '^[a-zA-ZáéíóúüñÁÉÍÓÚÜÑ ]{0,40}$', lastname: '', tooltipName: 'campo solo permite letras mayúsculas, letras minúsculas, letras con acento' },
        'NIT': { soft: '^[1-9][0-9]{0,9}$', hard: '^[1-9][0-9]{6,9}$', name: '^[a-zA-Z0-9][a-zA-Z1-9 ]{0,40}$', lastname: 'ocultar', tooltipName: 'campo solo permite números, letras mayúsculas, letras minúsculas' },
        'RUT': { soft: '^[1-9][0-9]{0,9}$', hard: '^[1-9][0-9]{6,9}$', name: '^[a-zA-Z0-9][a-zA-Z1-9 ]{0,40}$', lastname: 'ocultar', tooltipName: 'campo solo permite números, letras mayúsculas, letras minúsculas' }
    };

    const [objFormulario, setObjFormulario] = useState({
        tipo_documento: "",
        numero_identificacion: "",
        nombre: "",
        apellido_1: "",
        apellido_2: "",
        direccion: "",
        departamento: "",
        ciudad: "",
        barrio: "",
        telefono: "",
        email: "",
        terminos_condiciones: "No acepto",
        password_cliente: "",
        codigo_vendedor: "MPMA",
        condicion_de_pago: "001",
        tipo_de_cliente: "0009",
        grupo_descuento: "0032",
        lista_de_precios: "014",
        difusion_publicitaria_cliente: "",
        tipo_cliente_pagina: "B2C",
        tipo_descuento_cliente: "Cliente B2C",
        estado_cliente: "1",
        sucursal: "001"
    });

    const changeFormulario = (e) => {
        let { name, value } = e.target;
        if (name === 'terminos_condiciones') {
            if (objFormulario.terminos_condiciones === 'No acepto') {
                setObjFormulario({
                    ...objFormulario,
                    [name]: value
                });
            } else if (objFormulario.terminos_condiciones === 'Acepto') {
                setObjFormulario({
                    ...objFormulario,
                    [name]: 'No acepto'
                });
            }
            setMensajeValidacionTerminos('');
        } else if (name === 'tipo_documento') {
            setObjFormulario({
                ...objFormulario,
                numero_identificacion: '',
                nombre: '',
                [name]: value
            });
            setPatternIdentificacion(patterns[value]);
            setMensajeValidacionNombre('');
            setMensajeValidacionApellido('');
        } else {
            setObjFormulario({
                ...objFormulario,
                [name]: value
            });
        }
    }

    const consultarDepartamentos = async () => {
        try {
            const url = process.env.REACT_APP_SERVER + '/api/v1/customers/departments';
            const response = await axios.get(url);
            const data = response.data;
            let arrayDepartamentoAux = [{ name: "", id: "" }];
            for (let index = 0; index < data.length; index++) {
                arrayDepartamentoAux.push({
                    name: data[index].departamento,
                    id: data[index].id
                });
            }
            setArrayDepartamentos(arrayDepartamentoAux);
        } catch (error) {
            console.log(error);
        }
    }

    const consultarCiudades = async (idDepartamento) => {
        try {
            const url = process.env.REACT_APP_SERVER + '/api/v1/customers/cities/' + idDepartamento;
            const response = await axios.get(url);
            const data = response.data;
            let arrayCiudadesAux = [{ name: "", id: "" }];
            for (let index = 0; index < data.length; index++) {
                arrayCiudadesAux.push({
                    name: data[index].f013_descripcion,
                    id: data[index].f013_id
                });
            }
            setArrayCiudades(arrayCiudadesAux);
        } catch (error) {
            console.log(error);
        }
    }

    const changeDepartamentos = (e) => {
        consultarCiudades(e.target.value);
        changeFormulario(e);
    }

    const validacionTelefono = (e) => {
        const { value } = e.target;
        let mensaje = '';
        let validacion = true;
        if (value.length !== 10) {
            validacion = false;
            mensaje = 'El campo debe contener 10 dígitos';
        }
        setMensajeValidacionTelefono(mensaje)
        if (!validacion) {
            document.getElementById("telefono").classList.remove("is-valid");
            document.getElementById("telefono").classList.add("is-invalid");
            document.getElementById("telefono").setCustomValidity("invalid");
        } else {
            document.getElementById("telefono").classList.remove("is-invalid");
            document.getElementById("telefono").classList.add("is-valid");
            document.getElementById("telefono").setCustomValidity("");
        }
        changeFormulario(e);
    }

    const changeDireccion = (e) => {
        const { value } = e.target;
        if (value === "") {
            changeFormulario(e);
        } else {
            let regex = new RegExp("^[a-zA-Z0-9 ]+$");
            if (regex.test(value)) {
                changeFormulario(e);
            }
        }
        setMensajeValidacionDireccion('');
    }

    const changeEmail = (e) => {
        let validacion = true;
        const { value } = e.target;
        if (value === "") {
            validacion = false;
        }
        if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
            validacion = false;
        }
        // Verificar que el '@' esté antes del último '.'
        if (value.lastIndexOf('@') > value.lastIndexOf('.')) {
            validacion = false;
        }
        // Verificar que hay caracteres antes del '@' y después del último '.'
        if (value.indexOf('@') === 0 || value.lastIndexOf('.') === value.length - 1) {
            validacion = false;
        }
        // Verificar que haya al menos un carácter entre el '@' y el último '.'
        if (value.lastIndexOf('.') - value.indexOf('@') <= 1) {
            validacion = false;
        }
        // Verificar que el texto después del último punto tenga más de dos caracteres
        let ultimoPuntoIndex = value.lastIndexOf('.');
        let textoDespuesPunto = value.substring(ultimoPuntoIndex + 1);
        if (textoDespuesPunto.length <= 1) {
            validacion = false;
        }
        if (!validacion) {
            document.getElementById("email").classList.remove("is-valid");
            document.getElementById("email").classList.add("is-invalid");
            document.getElementById("email").setCustomValidity("invalid");
            setMensajeValidacionEmail('Debe ingresar un correo valido');
        } else {
            document.getElementById("email").classList.remove("is-invalid");
            document.getElementById("email").classList.add("is-valid");
            document.getElementById("email").setCustomValidity("");
            setMensajeValidacionEmail('');
        }
        changeFormulario(e);
    }

    const changeIdentificacion = (e) => {
        const { value } = e.target;
        if (value === "") {
            changeFormulario(e);
        } else {
            let regex = new RegExp(patternIdentificacion.soft);
            if (regex.test(value)) {
                changeFormulario(e);
            }
        }
    }

    const changeNombre = (e) => {
        const { value } = e.target;
        if (value === "") {
            changeFormulario(e);
        } else {
            let regex = new RegExp(patternIdentificacion.name);
            if (regex.test(value)) {
                changeFormulario(e);
            }
        }
        setMensajeValidacionNombre('');
        setMensajeValidacionApellido('');
    }

    function mostrarPassword() {
        var campo = document.getElementById("password_cliente_registro");
        if (campo.type === "password") {
            campo.type = "text";
            document.getElementById("iconoOcultar").style = "display:none";
            document.getElementById("iconoMostrar").style = "display:block";
        } else {
            campo.type = "password";
            document.getElementById("iconoOcultar").style = "display:block";
            document.getElementById("iconoMostrar").style = "display:none";
        }
    }

    const blurPassword = (e) => {
        changeFormulario(e);
        let letras_minusculas = "abcdefghyjklmnñopqrstuvwxyz";
        let letras_mayusculas = "ABCDEFGHYJKLMNÑOPQRSTUVWXYZ";
        let numeros = "0123456789";
        let simbolos = "!/%#$*";
        const { value } = e.target;
        let validacion = false;
        let mensaje = "";
        if (value !== "") {
            //valida la longitud
            if (value.length < 12) {
                mensaje = "Debe de contener minímo 12 carácteres";
            } else {
                //valida letra minusculas
                if (validacionCaracteres(value, letras_minusculas)) {
                    //valida letra mayúscula
                    if (validacionCaracteres(value, letras_mayusculas)) {
                        //valida números
                        if (validacionCaracteres(value, numeros)) {
                            //valida simbolo 
                            if (validacionCaracteres(value, simbolos)) {
                                validacion = true;
                            } else {
                                mensaje = "Debe de contener al menos 1 de los siguientes carácteres especiales (!, /, %, #, $, *)";
                            }
                        } else {
                            mensaje = "Debe de contener al menos 1 número";
                        }
                    } else {
                        mensaje = "Debe de contener al menos 1 letra mayúscula";
                    }
                } else {
                    mensaje = "Debe de contener al menos 1 letra minúscula";
                }
            }
        } else {
            validacion = true;
        }

        if (!validacion) {
            document.getElementById("password_cliente_registro").classList.remove("is-valid");
            document.getElementById("password_cliente_registro").classList.add("is-invalid");
            document.getElementById("password_cliente_registro").setCustomValidity("invalid");
        } else {
            document.getElementById("password_cliente_registro").classList.remove("is-invalid");
            document.getElementById("password_cliente_registro").classList.add("is-valid");
            document.getElementById("password_cliente_registro").setCustomValidity("");
        }
        setMensajeValidacionPassword(mensaje);
    }

    function validacionCaracteres(texto, caracteres) {
        for (let i = 0; i < texto.length; i++) {
            if (caracteres.indexOf(texto.charAt(i), 0) !== -1) {
                return true;
            }
        }
        return false;
    }

    const handleSubmit = async (event) => {
        setDisabledButton(true);
        event.preventDefault();
        const form = event.currentTarget;
        if (!form.checkValidity()) {
            event.preventDefault();
            event.stopPropagation();
            if (objFormulario.telefono === '') {
                setMensajeValidacionTelefono('El campo debe contener 10 dígitos');
            }
            if (objFormulario.email === '') {
                setMensajeValidacionEmail('Debe ingresar un correo valido');
            }
            if (objFormulario.nombre === '') {
                setMensajeValidacionNombre(patternIdentificacion.tooltipName);
            }
            if (objFormulario.apellido_1 === '') {
                setMensajeValidacionApellido(patternIdentificacion.tooltipName);
            }
            if (objFormulario.terminos_condiciones === 'No acepto') {
                setMensajeValidacionTerminos('Debe aceptar los términos y condiciones');
            }
            if (objFormulario.direccion === '') {
                setMensajeValidacionDireccion('campo solo permite números, letras mayusculas, letras minusculas')
            }
        } else {
            if (objFormulario.numero_identificacion < 0) {
                alert('El número de identificación no debe ser negativo')
            } else {
                if (objFormulario.numero_identificacion % 1 !== 0) {
                    alert('El número de identificación no debe llevar puntos o comas')
                } else {
                    if (location.pathname === '/registrarUsuario') {
                        const url = process.env.REACT_APP_SERVER + '/api/v1/customers/register';
                        const response = await axios.post(url, objFormulario);
                        const data = response.data;
                        if (data.result) {
                            setMensaje(data.message);
                            setShow(true);
                        } else {
                            setMensaje(data.message);
                            setShow(true);
                        }
                    } else {
                        const accessToken = cookies.get('accesToken');
                        const url = process.env.REACT_APP_SERVER + '/api/v1/customers/registerPorIpCarrito';
                        const { data } = await axios.post(url, objFormulario, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });
                        if (data.result) {
                            props.setDepartamento(objFormulario.departamento)
                            props.setCiudad(objFormulario.ciudad)
                            props.setDireccion(objFormulario.direccion)
                            cookies.set('accesToken', data.accesToken, { path: '/' });
                            cookies.set('user', data.usuario[0], { path: '/' });
                            props.registroUsuario();
                            props.mostrarAlert('success', 'title', data.message);
                            setDisabledButton(false);
                        } else {
                            console.log("Error al registrar el pedido y cliente");
                            setDisabledButton(false);
                        }
                    }
                }
            }
        }
        setValidated(true);
        setDisabledButton(false);
    };

    useEffect(() => {
        consultarDepartamentos();
    }, []);

    return (
        <Row style={{ alignItems: 'center' }}>
            <Col sm={12} md={12} lg={6} className="m-auto m-3 p-1 ">
                <h1 className="lh-1"><span className='segundoTitulo d-block display-4'>FORMULARIO</span><span className='tercerTitulo d-block text-dark display-1'>REGISTRO</span></h1>
            </Col>
            <Col style={{ width: "0px", height: "600px", margin: "10px 0px", padding: "1px", backgroundColor: "rgb(169 169 169)" }} sm={1} md={1} className="separadorVertical"></Col>
            <Col xs={12} sm={12} md={12} lg={5} className="m-auto ps-3 pe-5">
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label="Tipo-Documento" className={`mb-1 ${objFormulario.tipo_documento === '' ? 'no-float' : ''}`} >
                                <Form.Select
                                    size="sm"
                                    name="tipo_documento"
                                    className="form-control pb-0"
                                    required
                                    onChange={changeFormulario}
                                >
                                    <option></option>
                                    <option value={'CC'}>CC - Cédula de ciudadanía</option>
                                    <option value={'CE'}>CE - Cédula de extranjería</option>
                                    <option value={'TI'}>TI - Tarjeta de identidad</option>
                                    <option value={'NIT'}>NIT - Número de Identificación Tributaria</option>
                                    <option value={'RUT'}>RUT - Registro único tributario</option>
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label="Identificación" className='mb-1'>
                                <Form.Control size="sm" className="pb-0" type="text" id="numero_identificacion" name="numero_identificacion" pattern={patternIdentificacion.hard} value={objFormulario.numero_identificacion} onChange={changeIdentificacion} placeholder="Identificación" required autoComplete="off" />
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label={patternIdentificacion.lastname === '' ? 'Nombres' : 'Razón Social'} className='mb-1'>
                                <Form.Control size="sm" maxLength={40} type="text" name="nombre" pattern={patternIdentificacion.name} value={objFormulario.nombre} onChange={changeNombre} placeholder={patternIdentificacion.lastname === '' ? 'Nombres' : 'Razón Social'} required autoComplete="off" />
                                {mensajeValidacionNombre !== "" && <small className="text-danger">{mensajeValidacionNombre}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">{patternIdentificacion.tooltipName}</Tooltip>}>
                                <Button variant="outline-default"><Icon.InfoCircle /></Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row className={patternIdentificacion.lastname}>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Apellidos' className='mb-1'>
                                <Form.Control size="sm" maxLength={30} type="text" name="apellido_1" pattern={patternIdentificacion.name} value={objFormulario.apellido_1} onChange={changeNombre} placeholder="Apellidos" required={patternIdentificacion.lastname === 'ocultar' ? false : true} autoComplete="off" />
                                {mensajeValidacionApellido !== "" && <small className="text-danger">{mensajeValidacionApellido}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">{patternIdentificacion.tooltipName}</Tooltip>}>
                                <Button variant="outline-default"><Icon.InfoCircle /></Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Departamento' className={`mb-1 ${objFormulario.departamento === '' ? 'no-float' : ''}`}>
                                <Form.Select size="sm" className="form-control pb-0" name="departamento" required onChange={changeDepartamentos} >
                                    {
                                        arrayDepartamentos.map((dpto) => {
                                            return (
                                                <option key={dpto.id} value={dpto.id}>
                                                    {dpto.name}
                                                </option>
                                            );
                                        })
                                    }
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Ciudad' className={`mb-1 ${objFormulario.ciudad === '' ? 'no-float' : ''}`}>
                                <Form.Select size="sm" name="ciudad" className="form-control pb-0" required onChange={changeFormulario} >
                                    {
                                        arrayCiudades.map((dpto) => {
                                            return (
                                                <option key={dpto.id} value={dpto.id}>
                                                    {dpto.name}
                                                </option>
                                            );
                                        }
                                        )}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Barrio' className='mb-1'>
                                <Form.Control size="sm" type="text" name="barrio" placeholder="Barrio" onChange={changeFormulario} autoComplete="off" />
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Dirección' className='mb-1'>
                                <Form.Control size="sm" maxLength={40} type="text" name="direccion" placeholder="Dirección" required value={objFormulario.direccion} onChange={changeDireccion} pattern="^[a-zA-Z0-9 ]+$" autoComplete="off" />
                                {mensajeValidacionDireccion !== "" && <small className="text-danger">{mensajeValidacionDireccion}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">campo solo permite números, letras mayúsculas, letras minúsculas, máximo 40 caracteres</Tooltip>}>
                                <Button variant="outline-default"><Icon.InfoCircle /></Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Teléfono' className='mb-1'>
                                <Form.Control size="sm" type="number" name="telefono" id="telefono" placeholder="Teléfono" required onChange={validacionTelefono} autoComplete="off" />
                                {mensajeValidacionTelefono !== "" && <small className="text-danger">{mensajeValidacionTelefono}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                            <OverlayTrigger placement="top" overlay={<Tooltip id="button-tooltip">campo solo permite números</Tooltip>}>
                                <Button variant="outline-default"><Icon.InfoCircle /></Button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Correo' className='mb-1'>
                                <Form.Control size="sm" type="email" id="email" name="email" placeholder="Correo" onChange={changeEmail} autoComplete="off" required />
                                {mensajeValidacionEmail !== "" && <small className="text-danger">{mensajeValidacionEmail}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="p-0 d-flex align-items-top text-center">
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={11} className="pe-0">
                            <FloatingLabel label='Contraseña' className='mb-1'>
                                <Form.Control required style={{ borderTopRightRadius: "0", borderBottomRightRadius: "0" }} size="sm" type="password" name="password_cliente" id="password_cliente_registro" placeholder="Contraseña" onChange={blurPassword} autoComplete="off" />
                                {mensajeValidacionPassword !== "" && <small className="text-danger">{mensajeValidacionPassword}</small>}
                            </FloatingLabel>
                        </Col>
                        <Col xs={1} className="ps-0 pe-0 d-flex align-items-top text-center">
                            <Button style={{ zIndex: '10', marginLeft: '-42px', height: '45px', borderTopLeftRadius: "0", borderBottomLeftRadius: "0" }} variant="default" className="bg-warning text-white" onClick={mostrarPassword}><Icon.EyeFill id="iconoMostrar" style={{ display: "none" }} /><Icon.EyeSlashFill id="iconoOcultar" /></Button>
                            <small className="text-danger p-0">*</small>
                        </Col>
                    </Row>
                    <Form.Group as={Row}>
                        <Col xs={11} md={8}>
                            <Form.Label column>
                                <a target={'_new'} href={'./terminosCondiciones'}>Términos y condiciones<small className="text-danger">*</small></a>
                            </Form.Label>
                        </Col>
                        <Col xs={1}>
                            <Form.Check style={{ textAlign: 'left' }} onChange={changeFormulario}
                                name="terminos_condiciones"
                                value="Acepto"
                                className="mb-3"
                                type="checkbox"
                                id={`default-checkbox`}
                                required
                            />
                        </Col>
                        {mensajeValidacionTerminos !== "" && <small className="text-danger">{mensajeValidacionTerminos}</small>}
                    </Form.Group>
                    <Row className="mb-3" style={{ textAlign: 'center' }}>
                        <Col>
                            <Button type='submit' variant="outline-secondary" id="btnPedidoCliente" disabled={disabledButton}>{disabledButton ? 'Cargando...' : 'Registrarse'}</Button>
                        </Col>
                    </Row>
                </Form>
            </Col>
            <Modal
                show={show}
                onHide={() => setShow(false)}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{mensaje}</Modal.Title>
                </Modal.Header>
                <Modal.Footer>
                    <Link to={location.pathname === '/carrito' ? '/carrito' : '/inicioSesion'} className="btn btn-outline-warning">Aceptar</Link>
                </Modal.Footer>
            </Modal>
        </Row>
    );
}

export { RegistroUsuario };